import { render, staticRenderFns } from "./WorkerDashboard3.vue?vue&type=template&id=076d9ea2&scoped=true&"
import script from "./WorkerDashboard3.vue?vue&type=script&lang=js&"
export * from "./WorkerDashboard3.vue?vue&type=script&lang=js&"
import style0 from "./WorkerDashboard3.vue?vue&type=style&index=0&id=076d9ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076d9ea2",
  null
  
)

export default component.exports